const { useTheme } = require("@mui/material");

  export const useColorCodes = () => {
    const theme = useTheme();
    const getColorCodes = (status) =>{
    const value = String(status).toLowerCase();
    switch(value){
      case "completed": 
      case "verified": return {
        color: theme.palette.success.main, 
        classes: {chip: "glass-chip-success"}
      } //"#58d3c7ff";
      case "active": return {
        color: "rgba(88, 98, 255, 1)", 
        classes: {chip: "glass-chip-active"}
      } //"#58d3c7ff";
      case "disabled":
      case "paused": return {
        color: theme.palette.neutral[400], 
        classes:{chip:"glass-chip-disabled"}
      } ;
      case "draft": return {
        color: theme.palette.warning.main, 
        classes:{chip: "glass-chip-warning"}
      } ;
      case "failed":
      case "archived":
      case "archive": return {
        color: theme.palette.error.main, 
        classes:{chip: "glass-chip-error"}
      } ;
      case "running":
      case "pending": return {
        color: theme.palette.primary.main, 
        classes:{chip: "glass-chip-primary"}
      }
      default: return {
        color: theme.palette.primary.main, 
        classes:{chip: "glass-chip-primary"}
      } 
    }}
    return {getColorCodes}
  }